import { forwardRef, type Ref, type ReactNode, type HTMLAttributes } from 'react';

export interface AppShellSectionProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  /** Make this section scrollable (the rest stays pinned). */
  grow?: boolean;
  withBorder?: boolean;
}

/**
 * A section inside `<AppShell.Navbar>` (or Aside, Header, …). Use `grow`
 * to mark the scroll region so siblings stay anchored to the top/bottom.
 */
export const AppShellSection = forwardRef(function AppShellSection(
  { children, grow, withBorder, className, ...rest }: AppShellSectionProps,
  ref: Ref<HTMLDivElement>
): ReactNode {
  return (
    <div
      ref={ref}
      className={[
        'rr-app-shell__section',
        grow && 'rr-app-shell__section--grow',
        withBorder && 'rr-app-shell__section--bordered',
        className
      ].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </div>
  );
});
AppShellSection.displayName = 'AppShellSection';
